<template>
  <div class="topUp-money-page">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">

          <!-- <div class="head-img">
            <div class="head_avater flex-row">
              <div class="top-img">
                <img :src="userInfo.headImgUrl ? userInfo.headImgUrl : headImgUrl" alt="" style="width: 50px;height: 50px;border-radius: 50%;">
              </div>
              <div class="ml10">
                  <div class="mb10">{{userInfo.nickName}}</div>
                  <div class="flex-row">
                    <div class="color666">{{userInfo.mobile ?'电话号码':'身份证'}} {{userInfo.mobile ? userInfo.mobile : userInfo.idCardNo}}</div>
                    <div class="color666 ml30">可用余额： <span class="moneys">￥{{userInfo.walletAmount}}</span></div>
                  </div>
              </div>
            </div>
          </div> -->

          <div class="member-msg">
              <div class="member-border">
                <el-avatar class="img" shape="circle" size="small" v-if="userInfo.headImgUrl" :src="userInfo.headImgUrl"></el-avatar>
                <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
                <div class="rows member-box">
                  <p>{{ userInfo.nickName }}</p>
                  <div class="flex-row mt5">
                    <p class="mobile">{{ userInfo.mobile ? '手机号码:' : '身份证号码:'}} {{ userInfo.mobile ? userInfo.mobile : userInfo.idCardNo}}</p>
                    <p>可用余额: <span class="fontSize18">￥{{ userInfo.walletAmount }}</span></p>
                    <p class="ml20">可用积分: <span class="fontSize18">{{ userInfo.integralAmount }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          <div class="title-tabs">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>请选择充值金额</i></p>
            <div class="card-boxs">
              <div class="card-box" :class="item.show ? 'active' : ''" v-for="(item, index) in list" :key="index" @click="handleChangeList(item, index)">
                <div class="card-msg">
                  <p class="money">{{ item.rechargeAmount }}元</p>
                  <p class="fontSize14 color666 pt10">{{ item.remark }}</p>
                </div>
                <div class="payCheak" v-if="item.show"><img src="../../../assets/images/new/payRadio.png" alt=""></div>
              </div>
              <div class="custom-box">
				<div>充值金额</div>
                <el-input class="inputs textRight" v-model.trim="toUpMoney" maxlength="8" placeholder="请输入金额" @input="changeMoney"></el-input>
				 <p class="text">元</p>
			  </div>
			  <div class="custom-box" style="margin-top: 5px;" v-if="isShowGiveAmount">
				<div>赠送金额</div>
			    <el-input class="inputs textRight" v-model="form.giveAmount" maxlength="8" placeholder="请输入赠送金额"  :disabled="!canModifyGiveAmount"></el-input>
				<p class="text">元</p>
			  </div>
            </div>
          </div>
          <div class="staff-boxs mt60">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>请选择服务技师</i></p>
            <div class="right-content space-between">
              <span class="staff-btn mr10" >服务技师</span>
              <span class="jishi cur" @click="setStaff('item', 0)">{{staffIdName ? staffIdName : "请选择"}}></span>
            </div>
          </div>
        </div>
        <div class="pay-methods mt60" v-if="addEditShow">
          <v-payment :member="false" @payMentFun="paymentChange" data="recharge"></v-payment>
          <tips :type="'member'" class="mt60"></tips>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button class="left-btn" @click="back">取消</el-button>
            <el-button class="right-btn" type="primary" @click="saveMoney">确定收款￥{{ totalAmount || 0 }}</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
    <confimDdialog ref="confimFrom" @handleChange="confirmMoney" :money="money" :payWay="form.payWay" :payWayDescription="form.payWayDescription"></confimDdialog>
    <pay-form ref="payEditForm" @payFun="payMoney" @rePay="refreshToken" :source="'topUp'" :amount="Number(money)" :foot="true"></pay-form>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import staffSet from "../../components/staff-set";
import confimDdialog from "../../components/confim-dialog";
import drawer from "../../../components/common/drawer";
import member from "../../components/member";
import tips from "../../../components/tips";
import payForm from "../../components/pay";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { staffSet, member, drawer , tips, confimDdialog,payForm},
  data() {
    return {
      addEditShow: false,
      addEditTitle: "会员充值",
      toUpMoney: "",
      mobileNumber: "",
      totalAmount: 0,
      list: [],
      listSelected: [],
      form: {
        memberId: "",
        orderId: "",
        staffIds: "",
        amount: "",
        payWay: "",
		payWayDescription:"",
        verifyCode: "",
        payCheckType: "",
		giveAmount:""
      },
      amountForm: {},
      isPayWayHide: true,
      payWayList: [],
      clearTime: null,
      staffIds: {},
      staffIdName: "",
      staffIdNames: [],
      firststaff: [],
      money: 0,
      giveNum: 0,
      userInfo: {},
      headerImg: require("../../../assets/images/headerImg.png"),
      isSacn: false,
	  canModifyGiveAmount:false,
	  isShowGiveAmount:false
    };
  },
  watch: {
    listSelected() {
      this.totalAmount = 0;
      for (let i in this.listSelected) {
        this.totalAmount = this.listSelected[i].rechargeAmount;
      }
    }
  },
  created() {
    this.initTopUp();
  },
  destroyed () {
    localStorage.removeItem("payMobile")
  },
  methods: {
    initTopUp() {
      this.$on("set", function(item) {
        Object.assign(this.$data, this.$options.data());
        this.getPriceList();
        this.getMemberList(item)
        this.addEditShow = true;
        this.isSacn = false;
      });
    },
    getMemberList (id) {
      let arg = '';
      if (typeof id === 'string') {
        arg = id;
      } else if (typeof id === 'object') {
        arg = id.memberId;
      }
      this.$api.get(this.$url.member.get, {
        id: arg
      }).then(res => {
        if (res) {
          this.userInfo = res;
          this.form.memberId = res.id;
        }
      })
    },
    getPriceList () {// 获取列表
      this.$api.post(this.$url.order.listRechargeItem).then(res => {
        res.map((item,index) => {
          if (index == 0) {
            item.show = true;
          } else {
            item.show = false;
          }
          item.staffIds = [];
        })
        this.list = res;
        console.log(res);
        this.listSelected.push(res[0]);
        this.totalAmount = res[0].rechargeAmount;
		this.form.giveAmount = res[0].giveAmount;
		if(res.length>0)
		{
			this.isShowGiveAmount=(res[0].customRuleFlag=='yes');
		}
      })
    },
    back() {
      this.addEditShow = false;
      
    },
    handleChangeDrawer(val) {
      this.addEditShow = false;
    },
    removeToUpmoney() {
      if (this.toUpMoney != "") {
        this.toUpMoney = "";
        this.listSelected = [];
      }
    },
    changeMoney() {
      if (this.clearTime) {
        clearTimeout(this.clearTime);
      }
      // this.toUpMoney = this.bigNum(this.toUpMoney);
      this.toUpMoney = this.isMoneyTwo(this.toUpMoney)
       if (this.toUpMoney) {
          let index = 0;
		 
          for (let i=0; i<this.list.length;i++) {
            if (Number(this.list[i].rechargeAmount) > this.toUpMoney) {
              index = i > 0 ? i - 1 : i;
              break
            }
            if (Number(this.list[i].rechargeAmount) <= this.toUpMoney && i == this.list.length - 1) {
              index = this.list.length - 1;
            }
          }
          if (index == 0 && Number(this.list[index].rechargeAmount) > this.toUpMoney) {
            this.form.giveAmount = 0;
			this.canModifyGiveAmount=false;
          } else {
            this.form.giveAmount = this.list[index].giveAmount;
			this.canModifyGiveAmount= this.list[index].updateGiveAmountFlag=='yes';
          }
        } else {
          this.form.giveAmount = 0;
        }
        this.totalAmount = Number(this.toUpMoney);
        this.money = this.toUpMoney;
        if (Number(this.toUpMoney) == 0) {
          this.$message.warning("请输入或选择金额");
        }
        this.listSelected = [];
        this.listSelected.push({
          rechargeAmount: Number(this.toUpMoney),
          staffIds: [],
          show: false
        });
        if (this.staffIds.staffIds) {
          this.$set(this.listSelected[this.staffIds.nodeId], "staffIds", this.staffIds.staffIds);
        }
        for (let i in this.list) {
          this.$set(this.list[i], "show", false);
        }
    },
    handleChangeList(item, index) {
      this.money = item.money;
      this.listSelected = [];
      this.toUpMoney = "";
      this.form.giveAmount =item.giveAmount;
	  this.canModifyGiveAmount= item.updateGiveAmountFlag=='yes';
      this.listSelected.push(item);
      if (this.staffIds.staffIds) {
        this.$set(this.listSelected[this.staffIds.nodeId], "staffIds", this.staffIds.staffIds);
      } else {
        this.staffIdName = ""
      }
      for (let i in this.list) {
        this.$set(this.list[i], "show", false);
      }
      this.$set(this.list[index], "show", true);
    },

    setStaff(row, index) {
      if (this.staffIds.staffIds) {
        row = this.firststaff;
      } else {
        row = []
      }
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: row,
        index: index
      });
    },
    changePage(org) {
      if (org.staffIds) {
        if (this.listSelected.length == 0) {
          this.staffIds = org;
          org.staffIds.map(it => {
            this.firststaff.push(it)
          })
        } else {
          org.staffIds.map(it => {
            this.firststaff.push(it)
          })
          this.staffIds = org;
          this.$set(this.listSelected[org.nodeId], "staffIds", org.staffIds);
        }
        let a = []
        org.staffIds.map(item => {
          a.push(item.staffName)
        }) 
        this.staffIdName = a.join(",")
      }
    },
    payMoney(org) {
      if (org) {
        this.$emit("memberChange", true)
        this.addEditShow = false;
      }
      this.isSacn = false;
    },
    paymentChange(org) {
      this.form.payWay = org.payCode;
	  this.form.payWayDescription=org.payWayDescription;
    },

    saveMoney() {
      console.log(this.listSelected);
      if (this.isSacn) return
      if (this.form.memberId == "") {
        this.$message.warning("请选择会员");
        return false;
      }
	  if(this.form.payWay=="")
	  {
		  this.$message.warning("请选择支付方式");
		  return false;
	  }
      if (this.listSelected.length < 1) {
        this.$message.warning("请添加充值金额");
        return false;
      } else if (!this.listSelected[0].rechargeAmount) {
        this.$message.warning("充值金额不能为0");
        return false;
      } else if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(this.listSelected[0].rechargeAmount)) {
				this.$message.warning('请输入正确的金额数字，最多两位小数')
				return false
			}
      for (let i in this.listSelected) {
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning("请选择技师");
          return false;
        }
      }
      let arrIds = "",
        arrNames = "";
      for (let i in this.listSelected) {
        for (let j in this.listSelected[i].staffIds) {
          if (j == 0) {
            arrIds = this.listSelected[i].staffIds[j].staffId;
            arrNames = this.listSelected[i].staffIds[j].staffName;
          } else {
            arrIds += "," + this.listSelected[i].staffIds[j].staffId;
            arrNames += "," + this.listSelected[i].staffIds[j].staffName;
          }
        }
      }
      this.form.staffIds = arrIds;
      this.form.staffNames = arrNames;
      this.form.amount = this.listSelected[0].rechargeAmount;
      this.money = this.listSelected[0].rechargeAmount;
      this.$api.get(this.$url.order.getToken).then(res => {
        if (res) {
          this.form.repeatToken = res;
        }
      })
      this.$refs["confimFrom"].$emit("set", "member"); 
    },
    confirmMoney(val) {
      if (val) {
        this.form.payCode = val;
        if (
					this.form.payWay == 'tonglianStore' ||
					this.form.payWay == 'yinlianStore'
				) {
          this.isSacn = true;
					let parmar = {
						orderId: this.form.orderId,
						payWay: this.form.payWay,
						queryFlag: false,
					}
					this.$refs['payEditForm'].$emit('set', parmar)
					
				}
        this.form.millisecond = new Date().getTime();
        
        this.$api.post(this.$url.order.recharge,encrypt(JSON.stringify(this.form))).then(res => {
          if (res && res.status == 'fail') {
            let parmar = {
              orderId: res,
              payWay: this.form.payWay,
              queryFlag: false,
              close: true,
              closeMessage: res.message
            }
            this.$refs['payEditForm'].$emit('set', parmar);
            return
          }
          if (res) {
            if (this.form.payWay == "tonglianStore" || this.form.payWay == "yinlianStore") {
              this.isSacn = true;
              let parmar = {
                orderId: res,
                payWay: this.form.payWay,
                queryFlag: true,
              }
              this.$refs["payEditForm"].$emit("set", parmar);
              
              return
            } else {
              this.$message.success("支付成功");
              this.$emit("memberChange", true)
              this.addEditShow = false;
            }
            // if (localStorage.getItem("payMobile") == undefined || localStorage.getItem("payMobile") == null) {
            //   this.$message.success("支付成功");
              
            //   this.$emit("memberChange", true)
            // }
            // if (JSON.parse(localStorage.getItem("payMobile"))) {
            //   this.$message.success("支付成功");
            //   this.addEditShow = false;
              
            // }
          }
        })

      } else {
        this.isSacn = false;
      }
    },
    refreshToken() {
			this.isSacn = false;
			this.$api.get(this.$url.order.getToken).then((res) => {
				if (res) {
					this.form.repeatToken = res
				}
			})
		},
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.member-msg {
  padding: 16px 16px 0;
  .member-border {
    width: 100%;
    background-size: 100% 100%;
    color: white;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 12px 15px;
    background: #3388ff;
    box-sizing: border-box;
    .member-box {
      margin-left: 10px;
      .mobile {
        line-height: 1.6;
        margin-right: 20px;
      }
    }
  }
}
.payCheak {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
}
.pay-mains {
  padding: 0;
  .search-member {
    padding: 0 26px;
  }
  .title-tabs {
    // padding: 20px 26px;
    .title {
      border: 0;
    }
    .card-boxs {
      padding: 0 24px;
      display: flex;
      flex-wrap: wrap;
    }
    .card-box {
          width: calc(32% - 2px);
          height: 102px;
          margin-right: 2%;
          margin-bottom: 16px;
          position: relative;
          background: #F2F3F5;
          border: 1px solid #F2F3F5;
          border-radius: 4px;
          
          
          &:nth-of-type(3n) {
            margin-right: 0;
          }
          .card-msg {
            height: 102px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            font-weight: 700;
            .card-name {
              font-size: 18px;
              font-weight: 700;
            }
            .msg {
              text-align: left;
            }
          }
        }
        .active {
            background: #eaf4fe;
            border: 1px solid #3388FF;
          }
      

    .custom-box {
      width: 100%;
      border: 1px solid #DCDEE0;
      border-radius: 10px;
      display: flex;
      height: 48px;
      align-items: center;
      padding: 0 20px;
      .text {
        font-weight: 500;
      }
      /deep/.el-input {
        flex: 1;
        .el-input__inner {
          border: 0;
        }
      }
    }
  }
  .staff-boxs {
    .right-content {
      padding: 0 24px;
      box-sizing: border-box;
      .staff-btn {
        display: inline-block;
        font-size: 16px;
        text-align: center;
        color: #111;
      }
    }
  }
}

.btns {
  width: 100%;
  margin: 10px 24px;
  display: flex;
  align-items: center;
  .left-btn {
    width: 20%;
    font-size: 18px;
  }
  .right-btn {
    width: 80%;
    font-size: 18px;
  }
}
 /deep/ .textRight .el-input__inner{
	text-align: right !important;
}
</style>
